import { useState, useEffect } from "react";
import { useHistory } from "react-router";

const GoogleAnalyticsRedirect = (user = {}, mode = "") => {
  const { iam_role = "", brand_urls = [], stores = [] } = user;
  const [value, setValue] = useState(iam_role);
  const history = useHistory();
  const webview_url = mode === "webview" ? `/${mode}/` : "";
  useEffect(() => {
    if (iam_role === "super_admin") {
      history.push(`${webview_url}/admin/googleanalytics`);
    }
    if (iam_role === "brand_admin" && brand_urls.length === 1) {
      history.push(
        `${webview_url}brands/${brand_urls[0]}.pickup.ph/googleanalytics`,
      );
    }
    if (iam_role === "store_admin" && stores.length === 1) {
      history.push(
        `${webview_url}brands/${brand_urls[0]}.pickup.ph/stores/${stores[0]}/googleanalytics`,
      );
    }
    if (iam_role === "console_user") {
      history.push(
        `${webview_url}brands/${brand_urls[0]}.pickup.ph/stores/${stores[0]}/googleanalytics`,
      );
    }
  }, [value]);

  return value;
};

export default GoogleAnalyticsRedirect;
